import { Component, OnInit } from '@angular/core';
import { GermplasmDto } from '../shared/germplasm/model/germplasm.model';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../shared/modal/popup.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GermplasmPedigreeService } from '../shared/germplasm/service/germplasm.pedigree.service';
import { GermplasmDetailsPopupService } from './germplasm-details-popup.service';
import { GermplasmDetailsContext } from './germplasm-details.context';

@Component({
    selector: 'jhi-germplasm-details-graphviz-modal',
    templateUrl: './germplasm-details-graphviz-modal.component.html'
})
export class GermplasmDetailsGraphvizModalComponent implements OnInit {

    gid: number;
    includeDerivativeLines: boolean;

    constructor(public activeModal: NgbActiveModal,
                private germplasmPedigreeService: GermplasmPedigreeService) {

    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    ngOnInit(): void {
    }

}

@Component({
    selector: 'jhi-germplasm-details-graphviz-popup-modal',
    template: ''
})
export class GermplasmDetailsGraphvizModalPopupComponent implements OnInit {

    germplasm: GermplasmDto;

    constructor(private route: ActivatedRoute,
                private popupService: PopupService,
                private germplasmDetailsPopupService: GermplasmDetailsPopupService,
                private germplasmDetailsContext: GermplasmDetailsContext) {
    }

    ngOnInit(): void {
        const gid = Number(this.route.snapshot.paramMap.get('gid'));
        if (this.germplasmDetailsContext.openedFromWorkbench) {
            this.germplasmDetailsPopupService.close();
        }
        const modal = this.popupService.open(GermplasmDetailsGraphvizModalComponent as Component, { modalDialogClass: 'modal-autofit', backdrop: 'static' });
        modal.then((modalRef) => {
            modalRef.componentInstance.gid = gid;
            if (this.germplasmDetailsContext.openedFromWorkbench) {
                modalRef.result.then((result) => {
                    this.germplasmDetailsPopupService.open(gid, 'pedigree');
                }, () => {
                    this.germplasmDetailsPopupService.open(gid, 'pedigree');
                });
            }
        });
    }

}
